import { A } from '@expo/html-elements'
import { LinkProps } from '@expo/html-elements/build/elements/Text.types'
import * as React from 'react'

import { linkStyles } from './link-styles'

/**
 * Renders an anchor on web and a `Text` on native.
 * You must use this component instead of a `Button` or NativeBase's `Link`,
 * otherwise the link is not vertically aligned with the surrounding text in
 * Android (in iOS is fine).
 *
 * For external links use `href`, and for internal navigation use `onPress`.
 *
 * See docs: https://github.com/expo/expo/tree/main/packages/html-elements#a
 */
export function StyledLink({ children, style, ...props }: LinkProps) {
  return (
    <A style={[linkStyles.link, style]} {...props}>
      {children}
    </A>
  )
}
